import styled from 'styled-components';
export const Container = styled.div `
  margin-right: ${p => (p.marginRight ? `${p.marginRight}px` : '0px')};
  cursor: ${p => (p.isDisabled ? 'not-allowed' : 'pointer')};
  display: ${p => (p.justifyContent ? 'flex' : null)};
  justify-content: ${p => (p.justifyContent ? p.justifyContent : null)};
  width: ${p => (p.fullWidth ? '100%' : 'auto')};
`;
